<template>
  <div class="page-template">
    <div class="page-swiper">
      <van-search show-action shape="round" v-model="value" @search="_getShop" placeholder="输入名称搜索">
        <template #action>
          <div @click="_getShop" style="font-size:.28rem">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="page-hot" v-if="hot">
      <div class="hot-head">
        限时推荐
      </div>
      <span v-for="item in SalesShop" :key="item.id" class="hot-list" @click="tagClick(item)">{{item.name}}</span>
      <div style="clear:both"></div>
    </div>
    <div class="page-goods">
      <Empty :text="'没有结果哦！换一个词试试'" v-if="shopList.length == 0 && !hot"></Empty>
      <div class="goods-content" v-else>
        <div class="goods-item" v-for="item in shopList" :key="item.id" @click="$router.push('/m/details/' + item.id)">
          <img class="goods-img" :src="item.front" alt="GEEK" />
          <div class="goods-title">
            <van-tag round type="danger" v-show="item.hot == 1">推荐</van-tag>{{ item.name }}
          </div>
          <div class="goods-price">
            <div class="big-price">¥&nbsp;{{ item.price }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-suspend">
      <div class="item" @click="$router.push('/m')">
        <span class="iconfont icon-shouye1"></span>
        <p>返回首页</p>
      </div>
      <div class="item" @click="$router.push('/m/query')">
        <span class="iconfont icon-dingdanchaxun"></span>
        <p>订单查询</p>
      </div>
      <a :href="basic.help_qq">
        <div class="item">
          <span class="iconfont icon-lianxikefu"></span>
          <p>联系客服</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import {
    getShop,
    getSystem,
    getSalesShop
  } from "@/api/index";
  import {
    Dialog,
    Notify
  } from "vant";

  export default {
    data() {
      return {
        value: "",
        shopList: [],
        basic: {},
        hot:false,
        SalesShop: []
      };
    },
    created() {
      this._getSystem();
      this._getSalesShop()
    },
    methods: {
      // 获取商品
      _getShop() {
        getShop({
          pageIndex: 1,
          pageSize: 100,
          name: this.value,
        }).then((res) => {
          this.shopList = res.data.data;
          this.hot = false
        });
      },
      // 获取设置
      _getSystem() {
        getSystem().then((res) => {
          this.basic = res.data;
        });
      },
      // 客服弹窗
      help() {
        Dialog.alert({
          title: "帮助中心",
          message: this.basic.help_content,
        }).then(() => {});
      },
      // 获取销量商品
      _getSalesShop() {
        getSalesShop({
          num: 10
        }).then((res) => {
          if (res.data.salesShop.length > 0) {
            this.SalesShop = res.data.salesShop;
            this.hot = true
          }
        });
      },
      // 点击热门推荐
      tagClick(row){
        this.value = row.name
        this._getShop()
      }
    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";
  @deep: ~">>>";

  .page-template {
    background-color: rgb(245, 246, 247);
    min-height: 100vh;
    position: relative;
    overflow: hidden;

    .page-hot {
      background: #ffffff;
      min-height: 1rem;
      padding: .3rem;
      padding-top: 0;

      .hot-head {
        height: 0.7rem;
        line-height: 0.7rem;
        font-size: 0.28rem;


      }

      .hot-list {
        margin-right: .2rem;
        margin-bottom: .2rem;
        float: left;
        height: .48rem;
        font-size: .24rem;
        line-height: .48rem;
        border-radius: 3px;
        // width: 100%;
        color: #686868;
        background-color: #f0f2f5;
        padding-left: .26rem;
        padding-right: .26rem;
        box-sizing: border-box;
      }
    }

    .page-swiper {
      .van-cell {
        font-size: .28rem;
        line-height: .28rem;
      }

      .van-search__action {
        font-size: .28rem;
        line-height: .64rem;
      }

      @{deep}.van-icon {
        font-size: .32rem;
        margin-top: .03rem;
      }

      @{deep}.van-field__control {
        font-size: .28rem;
      }
    }

    .page-suspend {
      position: fixed;
      bottom: 65px;
      right: 20px;

      .item {
        width: 1.1rem;
        height: 1.1rem;
        background: rgba(0, 0, 0, 0.4);
        color: #ffffff;
        text-align: center;
        // line-height: 30px;
        margin-bottom: 10px;
        border-radius: 5px;

        .iconfont {
          font-size: .4rem;
        }

        p {
          height: .3rem;
          font-size: .2rem;
        }
      }
    }

    .page-goods {
      margin: 10px;
      min-height: 400px;
      margin-bottom: 0.2rem;

      .tit-img {
        width: 100%;
        margin-bottom: 0.05rem;
      }

      .goods-content {
        -moz-column-count: 2;
        /* Firefox */
        -webkit-column-count: 2;
        /* Safari 和 Chrome */
        column-count: 2;

        .skeleton-goods {
          -moz-page-break-inside: avoid;
          -webkit-column-break-inside: avoid;
          break-inside: avoid;
          width: 100%;
          margin-bottom: 0.2rem;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: rgba(116, 116, 116, 0.08) 0px 0px 10px 0px;
          -webkit-animation: van-skeleton-blink 1.2s ease-in-out infinite;
          animation: van-skeleton-blink 1.2s ease-in-out infinite;
          padding-bottom: 0.1rem;

          .skeleton-img {
            margin: 0.2rem;
            height: 3.25rem;
            border-radius: 0.1rem;
            background-color: #f2f3f5;
          }

          .skeleton-title {
            margin: 0.1rem 0.2rem;
            height: 0.2rem;
            background-color: #f2f3f5;
          }
        }

        .goods-item {
          -moz-page-break-inside: avoid;
          -webkit-column-break-inside: avoid;
          break-inside: avoid;
          width: 100%;
          margin-bottom: 0.2rem;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: rgba(116, 116, 116, 0.08) 0px 0px 10px 0px;

          .goods-img {
            width: 100%;
            height: 3.45rem;
          }

          .goods-title {
            font-size: 0.28rem;
            padding: 0 0.1rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            /* 行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin-top: 0.1rem;

            .van-tag {
              padding: 1px 2px;
              margin-right: 4px;
              font-size: .24rem;
              line-height: .32rem;
            }
          }

          .goods-price {
            padding: 0.15rem 0.2rem;
            overflow: hidden;

            .big-price {
              float: left;
              // display: inline-block;
              font-family: JDZhengHT-EN-Regular;
              color: red;
              font-weight: 600;
              font-size: 0.3rem;
            }

            .van-tag {
              float: right;
              padding: 2px 4px;
              vertical-align: middle;
            }
          }
        }
      }

      .goods-content::after {
        content: "";
        display: table;
        clear: both;
      }
    }

    .page-footer {
      margin: 0 auto;
      background-color: #fff;

      .common-links {
        box-sizing: border-box;
        padding: 0.3rem 0;
        border-bottom: 1px solid #e5e5e5;
        display: flex;
        justify-content: space-around;
      }

      .common-copyright {
        text-align: center;
        color: #848689;
        font-size: 14px;
        padding: 2vw;
      }
    }
  }
</style>